import React from 'react';
import styled from 'styled-components';
import { Body5 } from '@ui';

const Wrapper = styled.div`
  border: none;

  select {
    display: block;
    width: 100%;

    color: ${({ theme }) => theme.themeColors.text};
    cursor: pointer;

    option {
      color: ${({ theme }) => theme.themeColors.text};
      background: ${({ theme }) => theme.themeColors.component};
      font-size: 16px;
    }
  }
`;

const CheckboxWrapper = styled.div`
  background: transparent;
  width: 36px;
`;

const Box = styled.div`
  position: relative;
  cursor: pointer;
  overflow: hidden;

  transition: all 0.2s ease;

  background: transparent;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.themeColors.border};

  height: 20px;
  width: 20px;

  &::before,
  &::after {
    position: absolute;
    display: block;
    content: '';
    width: 2px;
    transition: all 0.2s ease;
  }
  &::before {
    height: 3px;
    left: 1px;
    top: 20px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }
  &::after {
    height: 7px;
    right: 3px;
    top: 20px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  ${({ theme, checked }) =>
    checked
      ? `
    background-color: ${theme.themeColors.primaryCtaButton};
    
      &::before {
        height: 6px;
        left: 4px;
        top: 9px;
        -webkit-transform: rotate(-40deg);
        transform: rotate(-40deg);
        background-color: ${theme.themeColors.component};
      }
      &::after {
        height: 13px;
        right: 6px;
        top: 3px;
        background-color: ${theme.themeColors.component};
      }
  `
      : ''};
`;

const ErrorMessage = styled.div`
  * {
    color: ${({ theme }) => theme.themeColors.error};
  }
`;

export const Checkbox = ({ name, value, label, onChange, error, stopPropagation }) => {
  const handleClick = React.useCallback(
    (e) => {
      if (stopPropagation) {
        e.stopPropagation();
      }
      const disabled = false;

      if (disabled) {
        return false;
      } else {
        onChange(name)(!value);
      }
    },
    [onChange, name, value]
  );

  return (
    <Wrapper>
      {label && (
        <label className="no-select">
          <Body5>{label}</Body5>
        </label>
      )}

      <CheckboxWrapper>
        <Box id={`checkbox-${name}`} checked={value} onClick={handleClick} />
      </CheckboxWrapper>

      {error && (
        <ErrorMessage className="sc-error-text">
          <Body5>{error}</Body5>
        </ErrorMessage>
      )}
    </Wrapper>
  );
};
